<template>
    <div>
        <TheHeader class="pc-header" />
        <BaseTitle :infor="infor" />
        <BaseListUlmoudle2 
            class="product-list-ul" 
            :list="list" 
        />
        <TheFooter class="pc-the-footer-other" />
    </div>
</template>

<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-other_pc-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseListUlmoudle2 from '@/components/module/BaseListUlmoudle2'

    import '@/assets/less/module/module-base-list-ulmoudle2_product-list-ul.less'

    export default {
        name: 'PCProduct',
        props: {
            json: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseListUlmoudle2
        },
        data: function(){
            return {
                getInfor: false
            }
        },
        computed: {
            infor: function(){
                let infor = this.json.infor;
                return infor;
            },
            list: function(){
                let list = this.json.list;
                return list;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>